export const NEGOTIATION_RATE = [
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.NO_NEGOTIATED_RATE',
    value: '0',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.NEGOTIATED_RATE',
    value: '1',
  },
];

export const NEGOTIATION_RATE_MAP = new Map<'1' | '0', string>(
  NEGOTIATION_RATE.map((item) => [item.value, item.label]) as any
);
